<template>
	<el-row class="languages">
		<el-col :span="5" class="box" v-for="(item, index) in Language" :key="index">
			<div class="langu">
				<span class="l-langu">{{ item.dicname }}</span>
				<span class="l-state" v-if="item.fbFlag == 2">配置中</span>
				<span class="l-state" @click="tip(item)" v-else>
					<el-switch
						:active-value="1"
						:inactive-value="0"
						v-model="item.fbFlag"
						v-loading="isDisabled"
					></el-switch>
				</span>
			</div>
			<div class="domain">
				<span
					>域名：<a
						:href="`https://${item.domainName}`"
						target="_blank"
						rel="noopener noreferrer"
						>{{ item.domainName }}</a
					></span
				>
			</div>
		</el-col>
	</el-row>
</template>
<script>
import chat from '@/backend/services/account/chat.js';
export default {
	props: {
		Language: {
			type: Array,
		},
	},
	data() {
		return {
			isDisabled: false,
		};
	},
	methods: {
		open: function () {
			this.$alert('插件已开启，可在几分钟后刷新网站查看效果', {
				confirmButtonText: '确定',
			});
		},
		close: function () {
			this.$alert('插件已关闭，可在几分钟后刷新网站查看效果', {
				confirmButtonText: '确定',
			});
		},
		async tip(i) {
			this.isDisabled = true;
			let id = i.id;
			await chat.getplugin({ id: id });
			let status = i.fbFlag;
			if (status === 1) this.open();
			else this.close();
			await this.$emit('query');
			this.isDisabled = false;
		},
	},
};
</script>
<style lang="scss" scoped>
.languages {
	.box {
		width: 198px;
		height: 92px;
		margin: 28px 25px;
		box-shadow: 0 4px 4px 0 rgba(67, 93, 255, 0.05);
		border-radius: 4px;
		border: 1px solid #cdcdcd;

		.langu {
			position: relative;
			margin: 15px 10px;

			.l-langu {
				width: 33px;
				height: 22px;
				font-size: 13px;
				font-weight: 500;
				color: #333;
				line-height: 22px;
			}

			.l-state {
				position: absolute;
				right: 5px;
				width: 42px;
				height: 20px;
				font-size: 13px;
				font-weight: 400;
				color: #999;
				line-height: 20px;
			}
		}

		.domain {
			width: 180px;
			height: 20px;
			overflow: hidden; //超出的文本隐藏
			text-overflow: ellipsis; //溢出用省略号显示
			white-space: nowrap; //溢出不换行
			margin-left: 10px;
			margin-bottom: 20px;
			font-size: 13px;
			font-weight: 400;
			color: #333;
			line-height: 20px;
		}
	}
}
</style>
